module.exports = __webpack_public_path__ + "static/media/blog1.64bf0fa2.webp";